export var PREFIX = 'cn-ui-m';
